import { CAMPAIGN_ACTION } from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'
import { CAMPAIGN_STATUS_OPTIONS } from '../../../util/campaign.helpers'
import { NUMBER_OF_RECORDS_PER_PAGE } from '../../../constants/app'

export const campaignListProfile = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    case CAMPAIGN_ACTION.ON_GET_CAMPAIGNS:
      return mergeToNewObject(state, {
        loading: true,
        pagination: {
          ...state.pagination,
          ...payload
        }
      })

    case CAMPAIGN_ACTION.ON_GET_CAMPAIGNS_SUCCESS:
      const { totalCount, campaigns } = payload
      return mergeToNewObject(state, {
        loading: false,
        data: campaigns,
        pagination: {
          ...state.pagination,
          totalTxCount: totalCount
        }
      })

    case CAMPAIGN_ACTION.ON_GET_CAMPAIGNS_FAILED:
      return mergeToNewObject(state, {
        loading: false
      })

    case CAMPAIGN_ACTION.CHANGE_LIST_STATE:
      const { property, value } = payload
      return mergeToNewObject(state, {
        [property]: value
      })

    case CAMPAIGN_ACTION.ON_CREATE_CAMPAIGN_SUCCESS:
      return mergeToNewObject(state, {
        status: CAMPAIGN_STATUS_OPTIONS.ALL
      })

    case CAMPAIGN_ACTION.ON_UPDATE_CAMPAIGN_SUCCESS:
      const data = state.data.map((record) =>
        payload.id === record.id
          ? { ...record, status: payload.status }
          : record
      )
      return mergeToNewObject(state, {
        data,
        // status: CAMPAIGN_STATUS_OPTIONS.ALL,
        selected: null
      })

    case CAMPAIGN_ACTION.ON_SELECT:
      const { data: selected, isListUpdate } = payload
      return mergeToNewObject(state, {
        selected,
        isListUpdate
      })

    case CAMPAIGN_ACTION.ON_RESET_LIST:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  pagination: {
    recordsPerPage: NUMBER_OF_RECORDS_PER_PAGE,
    pageNumber: 0,
    totalTxCount: 0
  },
  loading: false,
  data: [],
  selected: null,
  isListUpdate: false,
  status: CAMPAIGN_STATUS_OPTIONS.ALL
}

export const CAMPAIGN_LIST_PROFILE_DISPATCH = {
  STATUS: 'status'
}
